import { useState } from "react";
import { Icon, Label1 } from "@bms-ai/bms-ai-ui-lib/components";
import type { BriefPreviewData } from "../../context/MultipleFileUploadContext";

interface BriefPreviewProps {
  previewData: BriefPreviewData | null;
}

const BriefPreview: React.FC<BriefPreviewProps> = ({
  previewData,
}) => {
  // Local state to track which sheets are expanded
  const [expandedSheets, setExpandedSheets] = useState<Set<number>>(new Set([0]));

  const toggleSheetExpanded = (sheetIndex: number) => {
    setExpandedSheets((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(sheetIndex)) {
        newSet.delete(sheetIndex);
      } else {
        newSet.add(sheetIndex);
      }
      return newSet;
    });
  };
  return (
    <div className="preview-section">
      {/* <div className="preview-header-sticky">
        <Headline3 className="preview-section-label">Brief Preview</Headline3>
        <Label2 className="preview-section-subtext">
          Size details extracted from the uploaded brief file
        </Label2>
      </div> */}
      <div className="preview-area preview-area-filled">
        {previewData ? (
          // Use API data
          <div className="brief-preview-container">
            {/* Success Banner */}
            {/* <div className="brief-success-banner">
              Found {previewData.sizes.length} size(s) across{" "}
              {previewData.sizes.length} sheet(s)
            </div> */}

            {/* Sheet Sections */}
            {previewData.sizes.map((sizeInfo, sheetIndex) => (
              <div key={sheetIndex} className="brief-sheet-section">
                {/* Sheet Header */}
                <div
                  className="brief-sheet-header"
                  onClick={() => toggleSheetExpanded(sheetIndex)}
                >
                  <div className="brief-sheet-title">
                    Sheet: {sizeInfo.Sheet}
                  </div>
                  <Icon
                    type={
                      expandedSheets.has(sheetIndex) ? "chevron-up" : "chevron-down"
                    }
                    className="brief-sheet-chevron"
                  />
                </div>

                {/* Sheet Content */}
                {expandedSheets.has(sheetIndex) && (
                  <div className="brief-sheet-content">
                    <div className="brief-field-label">
                      Field: {sizeInfo.Field_Name}
                    </div>
                    <table className="brief-sizes-table">
                      <thead>
                        <tr>
                          <th>Size</th>
                          <th>Width</th>
                          <th>Height</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sizeInfo.Sizes.map((size, sizeIndex) => {
                          const dimensions = size.split('x');
                          const width = dimensions[0] || '-';
                          const height = dimensions[1] || '-';
                          return (
                            <tr key={sizeIndex}>
                              <td>{size}</td>
                              <td>{width}</td>
                              <td>{height}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          // Fallback to mock data
          <div className="brief-preview-container">
            <Label1 className="no-preview-text">
              No preview available for the uploaded brief.
            </Label1>
          </div>
        )}
      </div>
    </div>
  );
};

export default BriefPreview;
